import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
export const colorPropType = PropTypes.oneOfType([
    PropTypes.oneOf([
        'inherit',
        'primary',
        'secondary',
        'error',
        'info',
        'success',
        'warning'
    ]),
    PropTypes.string
]);
const useThemeColor = (color)=>{
    const theme = useTheme();
    if (color.includes('.')) {
        const [palette, variant] = color.split('.');
        return theme.palette?.[palette]?.[variant] || 'currentColor';
    }
    return theme.palette?.[color]?.main || 'currentColor';
};
export default useThemeColor;
